import React from "react";

import './footer.css';  // Import the Nav component's CSS (optional)

const Footer = () => {
    return (
        <>
            <div className="footer">
                <div className="container">
                    <div className="footer-inner">
                        <div className="footercard card">
                            <div className="card-body">
                                <img src="/img/reis-logo.png" alt="real-estate-integrated-solution" />
                            </div>
                            <div className="quick-links">
                                <a href="/">Support</a>
                                <a href="/">Term of service</a>
                                <a href="/">License   </a>
                            </div>
                        </div>
                        <div className="footercard card bdr-center" >

                            <div className="menu-links card-body">
                                <a href="/">About</a>
                                <a href="/">Government</a>
                                <a href="/">Solution   </a>
                                <a href="/">Contact   </a>
                            </div>
                            <div className="footer-bottom footer-social-icons">
                                <a href="/"><i class="fab fa-square-facebook"></i></a>
                                <a href="/"><i className="fab fa-linkedin"></i></a>
                                <a href="/"><i className="fab fa-square-twitter"></i></a>
                                <a href="/"><i className="fab fa-square-instagram"></i></a>
                             
                              
                            </div>
                        </div>
                        <div className="footercard card">

                            <div className=" card-body">
                                Unit GA-00-SZ-L1 Level 1, Gate Avenue,<br /> South Zone, Dubai International Financial Centre, Dubai, United Arab Emirates
                            </div>
                            <div className="footer-bottom">
                                <div className="reis-newsletter">
                                <input type="email" className="form-control" placeholder="Enter Email to subscribe to newsletter" /><button className="btn-plane btn btn-default"><i className="fas fa-paper-plane"></i></button></div>
                            </div>
                        </div>
                    </div>
                    <div className="copyright">REIS is powered by Deca4 Advisory FZE</div>
                </div>

            </div>
        </>
    );
};

export default Footer;